<template>
  <div>
    <div v-if="!swiper">
      <el-row class="artbox-ul">
        <el-col :span="6" class="artist" v-for="(item,index) in list" :key="index">
          <div class="itemwrap">
            <div class="mask"></div>
            <div class="headimg" :style="'background-image:url('+(item.Photo)+')'">
              <!-- <el-image  fit="cover">
                <div slot="error" class="image-slot">
                  <img src="../assets/image/morentx.jpg" alt="">
                </div>
              </el-image> -->
            </div>
            <div class="artinfo">
              <div class="name">{{item.ArtistName}}</div>
              <div class="des">
                <div class="des-l"><span>作品<span>{{item.ProductCount || 0}}</span></span><span>粉丝<span>{{item.LikeCount}}</span></span> </div>
              </div>
              <div class="txt">艺术家简介 </div>
              <div class="des-r">
                <div>
                  <el-button type="primary" @click="handleAddArtlike(item.ID,index)" :icon="item.IsLike?'':'el-icon-plus'" plain>{{item.IsLike?"取消关注":"关注"}}</el-button>
                </div>
                <div class="artist-home">
                  <el-button type="text">
                    <router-link :to="{path:'/artist/page',query:{id:item.ID}}">进入主页</router-link>
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="swiper">
      <swiper :options="swiperOption" class="artbox-ul">
        <swiper-slide v-for="(item, index) in list" v-bind:key="index">
          <div class="artist">
            <div class="itemwrap">
              <div class="mask"></div>
              <div class="headimg" :style="'background-image:url('+(item.headimg ||item.Photo)+')'">
                <!-- <el-image :src="item.headimg ||item.Photo" fit="cover">
                  <div slot="error" class="image-slot">
                    <img src="../assets/image/morentx.jpg" alt="">
                  </div>
                </el-image> -->
              </div>
              <div class="artinfo">
                <div class="name">{{item.Realname ||item.ArtistName}}</div>
                <div class="des">
                  <div class="des-l"><span>作品<span>{{item.productcount || item.ProductCount}}</span></span><span>粉丝<span>{{item.fanscount ||item.LikeCount}}</span></span> </div>
                </div>
                <!-- <div class="txt">艺术家简介 </div> -->
                <div class="des-r">
                  <div>
                    <el-button type="primary" @click="handleAddArtlike(item.id||item.ID,index)" :icon=" (item.islike ||item.IsLike)?'':'el-icon-plus'" plain>{{(item.islike ||item.IsLike)?"取消关注":"关注"}}</el-button>
                  </div>
                  <div class="artist-home">
                    <el-button type="text">
                      <router-link :to="{path:'/artist/page',query:{id:item.id ||item.ID}}">进入主页</router-link>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

  </div>

</template>
<style lang="scss" scoped>
@import "../assets/artist.scss";
</style>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'artist',
  props: {
    //列表数组
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    //是否开启幻灯片
    swiper: {
      type: Boolean,
      default: false
    },
    //幻灯片设置
    swiperOption: {
      type: Object,
      default: function () {
        return {
          spaceBetween: 0,
          slidesPerView: 5,
          pagination: '.swiper-pagination',
          autoplay: 5000,
          autoplayDisableOnInteraction: true,
          watchSlidesProgress: true,    //开启这个参数来计算每个slide的progress(进度、进程)
          //centeredSlides: true,    //设定为true时，活动块会居中，而不是默认状态下的居左。
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
        }
      }
    }
  },
  data() {
    return {

    }
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    handleAddArtlike(id, index) {
      let _this = this;
      console.log(id)
      _this.addLike(id).then(() => {
        if (_this.list[index].ID) {
          if (!_this.list[index].IsLike) {
            _this.list[index].IsLike = true
          } else {
            _this.list[index].IsLike = false
          }
        } else if (_this.list[index].id) {
          if (!_this.list[index].islike) {
            _this.list[index].islike = true
          } else {
            _this.list[index].islike = false
          }
        }
        _this.$message({
          message: '关注成功',
          type: 'success'
        });
      })
    }
  }
}
</script>